exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.xs-plugin-pullup-container {\n  text-align: center;\n}\n", ""]);

// exports
